import { useSelector } from 'react-redux';

import { store } from '../store';
import { selectProfile, selectRefreshToken, selectToken } from './keycloakSlice';

// using ony inside function component
export const useToken = () => useSelector(selectToken);
export const useRefreshToken = () => useSelector(selectRefreshToken);
export const useProfile = () => useSelector(selectProfile);
